import {
	AuditTrail, AuditTrailMultiSelectionFilterKeys,
	AuditTrailMultiSelectionFilters, AuditTrailSingleSelectionFilterKeys,
	AuditTrailSingleSelectionFilters,
} from '../../../../types/auditTrail'

export interface OrgSettingsAuditTrailState {
	list: Array<AuditTrail>
	count: number
	filters: AuditTrailFilters
}

export interface AuditTrailFilters {
	multiSelectionFilters: AuditTrailMultiSelectionFilters,
	singleSelectionFilters: AuditTrailSingleSelectionFilters
}

export enum ORG_SETTINGS_AUDIT_TRAIL_ACTION_TYPES {
	GET = 'ORG_SETTINGS_GET_AUDIT_TRAIL_LIST',
	RESET = 'ORG_SETTINGS_RESET_AUDIT_TRAIL_LIST',
	SET_FILTER_VALUE = 'ORG_SETTINGS_AUDIT_TRAIL_SET_FILTER',
	UNSET_FILTER_VALUE = 'ORG_SETTINGS_AUDIT_TRAIL_UNSET_FILTER',
	SET_FILTER_MULTI_SELECTION_VALUE = 'SET_FILTER_MULTI_SELECTION_VALUE',
	SET_FILTER_SINGLE_SELECTION_VALUE = 'SET_FILTER_SINGLE_SELECTION_VALUE'
}

export interface OrgSettingsAuditTrailsGetAction {
	type: ORG_SETTINGS_AUDIT_TRAIL_ACTION_TYPES.GET
	payload: { list: Array<AuditTrail>; count: number }
}

export interface OrgSettingsResetAuditTrailsInitAction {
	type: ORG_SETTINGS_AUDIT_TRAIL_ACTION_TYPES.RESET
}

export interface OrgSettingsAuditTrailSetMultiSelectionFilterValue {
	type: ORG_SETTINGS_AUDIT_TRAIL_ACTION_TYPES.SET_FILTER_MULTI_SELECTION_VALUE
	payload: {
		key: AuditTrailMultiSelectionFilterKeys
		value: Array<string>
	}
}

export interface OrgSettingsAuditTrailSetSingleSelectionFilterValue {
	type: ORG_SETTINGS_AUDIT_TRAIL_ACTION_TYPES.SET_FILTER_SINGLE_SELECTION_VALUE
	payload: {
		key: AuditTrailSingleSelectionFilterKeys
		value: string | number
	}
}


export interface OrgSettingsAuditTrailUnsetFilterValue {
	type: ORG_SETTINGS_AUDIT_TRAIL_ACTION_TYPES.UNSET_FILTER_VALUE
	payload: {
		key: AuditTrailSingleSelectionFilterKeys | AuditTrailMultiSelectionFilterKeys
		value: string
	}
}

export type OrgSettingsAuditTrailActions =
	| OrgSettingsAuditTrailsGetAction
	| OrgSettingsResetAuditTrailsInitAction
	| OrgSettingsAuditTrailUnsetFilterValue
	| OrgSettingsAuditTrailSetMultiSelectionFilterValue
	| OrgSettingsAuditTrailSetSingleSelectionFilterValue
